import type { RawTilesetEntry } from "../tilesetConfigEntry";

export const terrainEntries: RawTilesetEntry[] = [
	{
		key: "Rock",
		animations: [
			{
				loop: true,
				frames: [{ filename: "Rock.png", interval: 0 }],
			},
			{
				loop: true,
				frames: [{ filename: "Rock_2.png", interval: 0 }],
			},
			{
				loop: true,
				frames: [{ filename: "Rock_3.png", interval: 0 }],
			},
		],
	},
	{
		key: "CaveRock",
		sprite: "CaveRock.png",
	},
	{
		key: "MetalBlock",
		sprite: "MetalBlock.png",
	},
	{
		key: "ConcreteBlock",
		animations: [
			{
				loop: true,
				frames: [{ filename: "Concrete2.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 1,
				frames: [{ filename: "Concrete2.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 2,
				frames: [{ filename: "Concrete2.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 3,
				frames: [{ filename: "Concrete2.png", interval: 0 }],
			},
		],
	},
	{
		key: "WallCrack",
		animations: [
			{
				loop: true,
				tags: { stage: 0 },
				frames: [{ filename: "WallCrack1.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { stage: 1 },
				frames: [{ filename: "WallCrack2.png", interval: 0 }],
			},
		],
	},
	{
		key: "MossBrick",
		sprites: ["MossBrick_1.png", "MossBrick_2.png", "MossBrick_3.png"],
	},
	{
		key: "GrayStoneFloor1",
		sprite: "GrayStoneFloor1b.png",
	},
	{
		key: "GraySlab",
		sprite: "GraySlabb.png",
	},
	{
		key: "MossFloor",
		animations: [
			{
				loop: true,
				frames: [{ filename: "MossGrass.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 1,
				frames: [{ filename: "MossGrass.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 2,
				frames: [{ filename: "MossGrass.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 3,
				frames: [{ filename: "MossGrass.png", interval: 0 }],
			},
		],
	},
	{
		key: "WarningFloor",
		sprite: "WarningFloor.png",
	},
	{
		key: "Fence",
		sprite: "Fence.png",
	},
	{
		key: "FenceLight",
		sprite: "Fence_Light.png",
	},
	{
		key: "GrayStoneFloor2",
		animations: [
			{
				loop: true,
				frames: [{ filename: "GrayStoneFloor2b.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 1,
				frames: [{ filename: "GrayStoneFloor2b.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 2,
				frames: [{ filename: "GrayStoneFloor2b.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 3,
				frames: [{ filename: "GrayStoneFloor2b.png", interval: 0 }],
			},
		],
	},
	{
		key: "ConcreteFloor",
		animations: [
			{
				loop: true,
				frames: [{ filename: "ConcreteFloor.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 1,
				frames: [{ filename: "ConcreteFloor.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 2,
				frames: [{ filename: "ConcreteFloor.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 3,
				frames: [{ filename: "ConcreteFloor.png", interval: 0 }],
			},
		],
	},
	{
		key: "DarkConcreteFloor",
		animations: [
			{
				loop: true,
				frames: [{ filename: "DarkConcreteFloorA.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 1,
				frames: [{ filename: "DarkConcreteFloorA.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 2,
				frames: [{ filename: "DarkConcreteFloorA.png", interval: 0 }],
			},
			{
				loop: true,
				rotation: 3,
				frames: [{ filename: "DarkConcreteFloorA.png", interval: 0 }],
			},
		],
	},
	{
		key: "BlackFloor",
		sprite: "Black2.png",
	},
	{
		key: "BrownFloor",
		sprites: ["BrownFloor1.png", "BrownFloor2.png", "BrownFloor3.png"],
	},
	{
		key: "CaveFloor",
		sprites: ["CaveFloor_0.png", "CaveFloor_1.png", "CaveFloor_2.png"],
	},
	{
		key: "TornGround",
		sprites: ["BrownFloor1.png", "BrownFloor2.png", "BrownFloor3.png"],
	},
	{
		key: "WoodenBridgeFloor",
		sprite: "WoodenFloor.png",
	},
	{
		key: "WoodenFloor",
		sprite: "WoodenFloor.png",
	},
	{
		key: "WavyTile",
		sprite: "WavyTile.png",
	},
	{
		key: "MetalGridFloor",
		animations: [
			{
				loop: true,
				horizontalFlip: false,
				frames: [{ filename: "MetalGridFloorE.png", interval: 0 }],
			},
		],
	},
	{
		key: "DestroyedRock",
		sprites: ["DestroyedRock_3.png", "DestroyedRock_4.png"],
	},
	{
		key: "DestroyedConcreteBlock",
		animations: [
			{
				loop: true,
				frames: [{ filename: "DestroyedConcreteBlock.png", interval: 0 }],
			},
			{
				loop: true,
				horizontalFlip: true,
				frames: [{ filename: "DestroyedConcreteBlock.png", interval: 0 }],
			},
		],
	},
	{
		key: "BrickWall",
		sprite: "OrangeBrickWall.png",
	},
	{
		key: "BoxFloor",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["SW"],
				frames: [{ filename: "BoxFloor_0.png", interval: 0 }],
			},
			{
				loop: true,
				pointsTo: ["SE"],
				frames: [{ filename: "BoxFloor_1.png", interval: 0 }],
			},
			{
				loop: true,
				pointsTo: ["NE"],
				frames: [{ filename: "BoxFloor_2.png", interval: 0 }],
			},
			{
				loop: true,
				pointsTo: ["NW"],
				frames: [{ filename: "BoxFloor_3.png", interval: 0 }],
			},
		],
	},
	{
		key: "MetalBlockDiagonal",
		allowTransform: true,
		animations: [
			{
				loop: true,
				pointsTo: ["E"],
				frames: [{ filename: "ArrowMob_E.png", interval: 0 }],
			},
			{
				loop: true,
				pointsTo: ["NE"],
				frames: [{ filename: "MetalBlockDiagonal_NE.png", interval: 0 }],
			},
		],
	},
	{
		key: "Barrier",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "Barrier1a.png", interval: 100 },
					{ filename: "Barrier1b.png", interval: 100 },
				],
			},
		],
	},
];
